import { motion } from "framer-motion";
import {
  Droplets,
  Eye,
  Bot,
  Calendar,
  FileText,
  BarChart3,
  Home,
  HelpCircle,
} from "lucide-react";

const EDIT_OPTIONS = [
  {
    step: "question",
    label: "Question",
    icon: <HelpCircle className="gm-icon-sm" />,
    emoji: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M8.00004 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8.00004 1.3335C4.31814 1.3335 1.33337 4.31826 1.33337 8.00016C1.33337 11.6821 4.31814 14.6668 8.00004 14.6668Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.06006 5.99989C6.21679 5.55434 6.52616 5.17863 6.93336 4.93931C7.34056 4.7 7.81932 4.61252 8.28484 4.69237C8.75036 4.77222 9.1726 5.01424 9.47678 5.37558C9.78095 5.73691 9.94743 6.19424 9.94673 6.66656C9.94673 7.99989 7.94673 8.66656 7.94673 8.66656"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 11.3335H8.00667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    step: "liquidity",
    label: "Liquidity",
    icon: <Droplets className="gm-icon-sm" />,
    emoji: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M2 2V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H14"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.66663 7.47145C4.66664 7.38321 4.70165 7.29858 4.76396 7.23611L6.09729 5.90278C6.12826 5.87174 6.16504 5.84711 6.20554 5.8303C6.24603 5.8135 6.28945 5.80485 6.33329 5.80485C6.37714 5.80485 6.42055 5.8135 6.46105 5.8303C6.50154 5.84711 6.53833 5.87174 6.56929 5.90278L8.76396 8.09745C8.79492 8.12849 8.83171 8.15312 8.8722 8.16992C8.9127 8.18673 8.95611 8.19538 8.99996 8.19538C9.0438 8.19538 9.08722 8.18673 9.12771 8.16992C9.16821 8.15312 9.205 8.12849 9.23596 8.09745L12.0973 5.23611C12.1439 5.18942 12.2033 5.15759 12.2679 5.14465C12.3326 5.13172 12.3997 5.13827 12.4606 5.16346C12.5216 5.18866 12.5737 5.23137 12.6104 5.2862C12.647 5.34102 12.6666 5.40549 12.6666 5.47145V10.6668C12.6666 10.8436 12.5964 11.0132 12.4714 11.1382C12.3463 11.2632 12.1768 11.3334 12 11.3334H5.33329C5.15648 11.3334 4.98691 11.2632 4.86189 11.1382C4.73686 11.0132 4.66663 10.8436 4.66663 10.6668V7.47145Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    step: "outcomes",
    label: "Outcomes",
    icon: <BarChart3 className="gm-icon-sm" />,
    emoji: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M8.00004 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8.00004 1.3335C4.31814 1.3335 1.33337 4.31826 1.33337 8.00016C1.33337 11.6821 4.31814 14.6668 8.00004 14.6668Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.6667 8H12"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.00004 8H1.33337"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 4.00016V1.3335"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 14.6667V12"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    step: "resolver",
    label: "Resolver",
    icon: <Bot className="gm-icon-sm" />,
    emoji: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M8.00004 5.33317V2.6665H5.33337"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 5.3335H3.99996C3.26358 5.3335 2.66663 5.93045 2.66663 6.66683V12.0002C2.66663 12.7365 3.26358 13.3335 3.99996 13.3335H12C12.7363 13.3335 13.3333 12.7365 13.3333 12.0002V6.66683C13.3333 5.93045 12.7363 5.3335 12 5.3335Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.33337 9.3335H2.66671"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.3334 9.3335H14.6667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 8.6665V9.99984"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6 8.6665V9.99984"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    step: "resolution",
    label: "Timeline",
    icon: <Calendar className="gm-icon-sm" />,
    emoji: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M5.33337 1.3335V4.00016"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.6666 1.3335V4.00016"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.6667 2.6665H3.33333C2.59695 2.6665 2 3.26346 2 3.99984V13.3332C2 14.0696 2.59695 14.6665 3.33333 14.6665H12.6667C13.403 14.6665 14 14.0696 14 13.3332V3.99984C14 3.26346 13.403 2.6665 12.6667 2.6665Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2 6.6665H14"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    step: "visibility",
    label: "Visibility",
    icon: <Eye className="gm-icon-sm" />,
    emoji: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M14.36 10H11.3333C10.9797 10 10.6406 10.1405 10.3905 10.3905C10.1405 10.6406 10 10.9797 10 11.3333V14.36"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.66663 2.22656V3.33323C4.66663 3.86366 4.87734 4.37237 5.25241 4.74744C5.62749 5.12252 6.13619 5.33323 6.66663 5.33323C7.02025 5.33323 7.35939 5.4737 7.60943 5.72375C7.85948 5.9738 7.99996 6.31294 7.99996 6.66656C7.99996 7.3999 8.59996 7.9999 9.33329 7.9999C9.68691 7.9999 10.0261 7.85942 10.2761 7.60937C10.5262 7.35932 10.6666 7.02018 10.6666 6.66656C10.6666 5.93323 11.2666 5.33323 12 5.33323H14.1133"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.33337 14.6335V12.0002C7.33337 11.6465 7.19289 11.3074 6.94284 11.0574C6.69279 10.8073 6.35365 10.6668 6.00003 10.6668C5.64641 10.6668 5.30727 10.5264 5.05722 10.2763C4.80718 10.0263 4.6667 9.68712 4.6667 9.3335V8.66683C4.6667 8.31321 4.52622 7.97407 4.27618 7.72402C4.02613 7.47397 3.68699 7.3335 3.33337 7.3335H1.3667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.00004 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8.00004 1.3335C4.31814 1.3335 1.33337 4.31826 1.33337 8.00016C1.33337 11.6821 4.31814 14.6668 8.00004 14.6668Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    step: "description",
    label: "Description",
    icon: <FileText className="gm-icon-sm" />,
    emoji: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M10.6666 2.6665H12C12.3536 2.6665 12.6927 2.80698 12.9428 3.05703C13.1928 3.30708 13.3333 3.64622 13.3333 3.99984V5.33317"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.2267 10.4428C14.3582 10.3113 14.4625 10.1552 14.5336 9.98341C14.6048 9.8116 14.6414 9.62745 14.6414 9.44149C14.6414 9.25552 14.6048 9.07138 14.5336 8.89957C14.4625 8.72776 14.3582 8.57165 14.2267 8.44016C14.0952 8.30866 13.9391 8.20435 13.7673 8.13318C13.5955 8.06202 13.4113 8.02539 13.2253 8.02539C13.0394 8.02539 12.8552 8.06202 12.6834 8.13318C12.5116 8.20435 12.3555 8.30866 12.224 8.44016L8.88401 11.7815C8.72551 11.9399 8.60949 12.1357 8.54667 12.3508L7.98867 14.2642C7.97194 14.3215 7.97094 14.3823 7.98577 14.4402C8.0006 14.4981 8.03072 14.5509 8.07297 14.5932C8.11523 14.6354 8.16806 14.6656 8.22595 14.6804C8.28383 14.6952 8.34464 14.6942 8.40201 14.6775L10.3153 14.1195C10.5305 14.0567 10.7263 13.9407 10.8847 13.7822L14.2267 10.4428Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.33329 14.6665H3.99996C3.64634 14.6665 3.3072 14.526 3.05715 14.276C2.8071 14.0259 2.66663 13.6868 2.66663 13.3332V3.99984C2.66663 3.64622 2.8071 3.30708 3.05715 3.05703C3.3072 2.80698 3.64634 2.6665 3.99996 2.6665H5.33329"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 1.3335H6.00004C5.63185 1.3335 5.33337 1.63197 5.33337 2.00016V3.3335C5.33337 3.70169 5.63185 4.00016 6.00004 4.00016H10C10.3682 4.00016 10.6667 3.70169 10.6667 3.3335V2.00016C10.6667 1.63197 10.3682 1.3335 10 1.3335Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
];

export const EditPickerBubbles = ({ onSelectStep, onRestart }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="gm-edit-picker"
    >
      <div className="gm-edit-picker-chips">
        {EDIT_OPTIONS.map((option, i) => (
          <motion.button
            key={option.step}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onSelectStep(option.step)}
            className="gm-edit-chip"
          >
            <span className="gm-edit-chip-emoji">{option.emoji}</span>
            {option.label}
          </motion.button>
        ))}
      </div>
      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        whileTap={{ scale: 0.95 }}
        onClick={onRestart}
        className="gm-edit-restart"
      >
        <Home className="gm-icon-xs" />
        Start over
      </motion.button>
    </motion.div>
  );
};
